import * as actionTypes from "./actionTypes";
import api from "../../api";
import userApi from "../../userAPI";
import * as APIConstants from "../APIConstants";
import { Translate } from "../../utils/Translate";
import { getThirdPartyUserSubscription } from "../../ClubManager/index";
import logger from "../../utils/logger"
const config = require('../../assets/config.json');  

export const GetUserSubscription = () => { 
   const thirdPartySubscriptionCheck = (config.thirdPartySubscriptionCheck || config.isThirdPartyEnabled);
  return dispatch => {
    thirdPartySubscriptionCheck ? dispatch(getThirdPartyUserSubscription()) : dispatch(getWexerUserSubscription());
  };
};  
 
export const resetSubscriptionStatus = () => {
  return dispatch => {
    dispatch({ type: actionTypes.RESET_SUBSCRIPTION_STATUS });
  };
};

export const getUserSubscriptionDetails = () => {
  return dispatch => {
    const url = APIConstants.getUserSubscriptionDetailsAPI
    dispatch({
      type: actionTypes.FETCH_USER_SUBSCRIPTION_DETAILS_START
    });
    var body = {
      tenantId : config.name
    }
    userApi.post(url,body).then(response => {
      if(response.ok) {
        const subscriptionDetails = response?.data[response.data.length-1]
        dispatch({
          type: actionTypes.FETCH_USER_SUBSCRIPTION_DETAILS_SUCCESS,
          subscriptionDetails: subscriptionDetails,
          status: subscriptionDetails.status
        });
      } else if(response.status === 404) {
        dispatch({
          type: actionTypes.FETCH_USER_SUBSCRIPTION_DETAILS_FAIL,
          subscriptionDetails: null,
          statusCode: 404,
          userSubscripton: null,
          status: null
        });
      }
      else if(response.status === 500) {
        dispatch({
          type: actionTypes.FETCH_USER_SUBSCRIPTION_DETAILS_FAIL,
          subscriptionDetails: null,
          statusCode: 500,
          userSubscripton: null,
          status: null
        })
      }
    })
  };
}

export const getWexerUserSubscription = () => {
  return dispatch => { 
    var url = APIConstants.getUserSubscriptionAPI
    dispatch({
      type: actionTypes.FETCH_USER_SUBSCRIPTION_START
    });
    var body = {
      tenantId : config.name 
    }
    userApi.post(url,body).then(response=>{
      if(response.ok){
        if(response.status === 200){
          dispatch({
            type: actionTypes.FETCH_USER_SUBSCRIPTION_SUCCESS,
            userSubscripton: response.data,
            status: response.data?.status
          });
        }
        else if(response.status === 204){
          dispatch({
            type: actionTypes.FETCH_USER_SUBSCRIPTION_FAIL,
            userSubscripton: null,
            status: null
          });
        }
      } else {
            dispatch({
              type: actionTypes.FETCH_USER_SUBSCRIPTION_FAIL,
              userSubscripton: null,
              status: null
            })
          }
    })
  };
}
export const GetSubscriptionProduct = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.FETCH_SUBSCRIPTION_PRODUCT_START
    });
    api.get(APIConstants.getSubscriptionProductAPI).then(response => {
      if (response.ok) {
        dispatch({
          type: actionTypes.FETCH_SUBSCRIPTION_PRODUCT_SUCCESS,
          subscriptionProduct: response.data,
          currency:response.data&&response.data.length>0&&response.data[0].plans&&response.data[0].plans.length>0?response.data[0].plans[0].currency&&response.data[0].plans[0].currency.toUpperCase():config.currency
        });
      } else {
        dispatch({
          type: actionTypes.FETCH_SUBSCRIPTION_PRODUCT_FAIL,
          errorMsg: Translate({ id: "ApiResponseStrings.InternalServerError" })
        });
      }
    });
  };
};

export const PurchaseSubscription = (planId, sourceToken, productId, discountCode) => {
  let purchasePlanData = {
    planId: planId,
    sourceToken: sourceToken,
    productId: productId,
    paymentMethod: 2
  };
  if (discountCode !== "" && discountCode !== null) {
    purchasePlanData.DiscountCode = discountCode
  }
  return dispatch => {
    dispatch({
      type: actionTypes.PURCHASE_SUBSCRIPTION_START
    });

    userApi
      .post(APIConstants.purchaseSubscriptionAPI, purchasePlanData)
      .then(response => {
        if (response.ok) {
          let Notification = Translate({
            id: "Subscription.Subscriptionpurchased"
          });
          dispatch({
            type: actionTypes.PURCHASE_SUBSCRIPTION_SUCCESS,
            result: response.data
          });
          dispatch(GetUserSubscription);
          dispatch({
            type: actionTypes.NOTIFY_USER,
            NotificationText: Notification
          });
        } else if (response.status === 409) {
          if(response.data&&response.data.message&&response.data.message.includes('1032')){
            dispatch({
              type: actionTypes.PURCHASE_SUBSCRIPTION_FAIL,
              errorMsg: Translate({ id: "Subscription.DiscountCodeAlreadyUsedError" }),
              couponCodeError:true
            });
          }
          else if(response.data&&response.data.message&&response.data.message.includes('1019')){
            dispatch({
              type: actionTypes.PURCHASE_SUBSCRIPTION_FAIL,
              errorMsg: Translate({ id: "ApiResponseStrings.InvalidCoupon" }),
              couponCodeError:true
            });
          }
          else
            dispatch({
              type: actionTypes.PURCHASE_SUBSCRIPTION_FAIL,
              errorMsg: Translate({ id: "ApiResponseStrings.AlreadyActiveSubscription" })
            });
        }
        else {
          dispatch({
            type: actionTypes.PURCHASE_SUBSCRIPTION_FAIL,
            errorMsg:
              response != null && response.data != null
                ? response.data.message
                : ""
          });
        }
      });
  };
};
export const VerifyDiscountCouponCode = freeAccessCode => {

  return dispatch => {
    dispatch({
      type: actionTypes.VERIFY_DISCOUNT_START
    });
    var url = APIConstants.verifyFreeAccessCode + freeAccessCode;
    api.post(url).then(response => {
      if (response.status === 200) {
        dispatch({
          type: actionTypes.VERIFY_DISCOUNT_SUCCESS,
          data: response.data
        });
      } else {
        let msg = "";
        if (response.status === 400) {
          msg = Translate({ id: "ApiResponseStrings.InvalidDataPassed" });
        } else if (response.status === 409) {
          msg = Translate({ id: "ApiResponseStrings.InvalidCoupon" });
        } else {
          msg = Translate({ id: "ApiResponseStrings.InternalServerError" });
        }
        dispatch({
          type: actionTypes.VERIFY_DISCOUNT_FAIL,
          errorMsg: msg,
          result: response.data,
          couponCodeError:response.status===409?true:false
        });
      }
    });
  };
};
export const RemoveCouponCode = () => {

  return dispatch => {

    dispatch({
      type: actionTypes.REMOVE_DISCOUNT_COUPON,

    });

  };
};
export const VerifyAndPurchaseFreeSubscription = freeAccessCode => {

  return dispatch => {
    dispatch({
      type: actionTypes.VERIFY_FREEACCESSCODE_START
    });
    var url = APIConstants.verifyFreeAccessCode + freeAccessCode;
    api.post(url).then(response => {
      if (response.status === 200) {
        dispatch(GetFreeSubscription(freeAccessCode));
      } else {
        let msg = "";
        if (response.status === 400) {
          msg = Translate({ id: "ApiResponseStrings.InvalidDataPassed" });
        } else if (response.status === 409) {
          msg = Translate({ id: "ApiResponseStrings.InvalidCoupon" });
        } else {
          msg = Translate({ id: "ApiResponseStrings.InternalServerError" });
        }
        dispatch({
          type: actionTypes.VERIFY_FREEACCESSCODE_FAIL,
          errorMsg: msg
        });
      }
    });
  };
};

export const GetFreeSubscription = code => {
  let purchasePlanData = {
    DiscountCode: code
  };
  return dispatch => {
    dispatch({
      type: actionTypes.FETCH_USER_SUBSCRIPTION_START
    });
    userApi
      .post(APIConstants.getFreeAccessSubscription, purchasePlanData)
      .then(response => {
        if (response.ok) {
          if (response.data.status === "active" || response.data.status === "trialing") {
            dispatch({
              type: actionTypes.FETCH_USER_SUBSCRIPTION_SUCCESS,
              status: true,
              userSubscripton: response.data,
            });
          } else {
            dispatch({
              type: actionTypes.FETCH_USER_SUBSCRIPTION_SUCCESS,
              status: false,

            });
          }
          let Notification = Translate({
            id: "Subscription.Subscriptionpurchased"
          });
          dispatch({
            type: actionTypes.GET_FREE_SUBSCRIPTION_SUCCESS,
            result: response.data
          });
          dispatch({
            type: actionTypes.NOTIFY_USER,
            NotificationText: Notification
          });
          dispatch(GetUserSubscription)
        } else {
          let msg = "";
        if (response.status === 400) {
          msg = Translate({ id: "ApiResponseStrings.InvalidDataPassed" });
        } else if (response.status === 409) {
          msg = Translate({ id: "ApiResponseStrings.InvalidCoupon" });
        } else {
          msg = Translate({ id: "ApiResponseStrings.InternalServerError" });
        }
          dispatch({
            type: actionTypes.GET_FREE_SUBSCRIPTION_FAIL,
            errorMsg: msg
          });
        }
      });
  };
};

export const CancelSubscription = () => {
  var url = APIConstants.cancelUserSubscriptionAPI;
  var body = {
    tenantId : config.name
  }
  return dispatch => {
    dispatch({
      type: actionTypes.CANCEL_SUBSCRIPTION_START
    });
    userApi.delete(url,{},{data: body}).then(response => {
      if (response.ok) {
        dispatch({
          type: actionTypes.CANCEL_SUBSCRIPTION_SUCCESS
        });
        dispatch(getUserSubscriptionDetails());
      } else {
        dispatch({
          type: actionTypes.CANCEL_SUBSCRIPTION_FAIL,
          errorMsg:
            response != null && response.data != null
              ? response.data.message
              : ""
        });
      }
    });
  };
};

export const ResumeSubscription = (subscriptionTag, planId, productId) => {
  var data = {
    PlanId: planId,
    SubscriptionId: subscriptionTag,
    ProductId: productId
  };
  var url = APIConstants.resumeUserSubscriptionAPI + "/" + subscriptionTag;
  return dispatch => {
    dispatch({
      type: actionTypes.RESUME_SUBSCRIPTION_START
    });
    userApi.put(url, data).then(response => {
      if (response.ok) {
        dispatch({
          type: actionTypes.RESUME_SUBSCRIPTION_SUCCESS
        });
        dispatch(GetUserSubscription());
      } else {
        dispatch({
          type: actionTypes.RESUME_SUBSCRIPTION_FAIL
        });
      }
    });
  };
};

export const GetSubscriptionPortalLink = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.FETCH_SUBSCRIPTION_PORTAL_LINK_START
    });
    userApi.post(APIConstants.getSubscriptionPortalLinkAPI).then(response => {
      if (response.ok) {
        dispatch({
          type: actionTypes.FETCH_SUBSCRIPTION_PORTAL_LINK_SUCCESS,
          payload: response.data
        });
      } else {
        dispatch({
          type: actionTypes.FETCH_SUBSCRIPTION_PORTAL_LINK_FAIL,
          errorMsg: Translate({ id: "ApiResponseStrings.InternalServerError" })
        });
      }
    });
  };
};
